export const KEYFRAME_MAP = 'KEYFRAME_MAP';
export const KEYFRAME = 'KEYFRAME';
